import Vector3 from './Vector3';

export default class Quaternion {
	constructor (x, y, z, w) {
		this.x = x;
		this.y = y;
		this.z = z;
		this.w = w;
	}

	set (x, y, z, w) {
		this.x = x;
		this.y = y;
		this.z = z;
		this.w = w;
		return this;
	}

	// setArray (arr) {
	// 	this.x = arr[0];
	// 	this.y = arr[1];
	// 	this.z = arr[2];
	// 	this.w = arr[3];
	// 	return this;
	// }

	copy () {
		return new Quaternion(this.x, this.y, this.z, this.w);
	}

	calculateW () {
		this.w = -Math.sqrt(Math.abs(1 - this.x * this.x - this.y * this.y - this.z * this.z));
		return this;
	}

	invert () {
		this.x = -this.x;
		this.y = -this.y;
		this.z = -this.z;
		return this;
	}

	getLength () {
		return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
	}

	normalize () {
		var length = Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
		this.x /= length;
		this.y /= length;
		this.z /= length;
		this.w /= length;
		return this;
	}

	multiply (quat) {
		var x0 = this.x;
		var y0 = this.y;
		var z0 = this.z;
		var w0 = this.w;

		var x1 = quat.x;
		var y1 = quat.y;
		var z1 = quat.z;
		var w1 = quat.w;

		this.x = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
		this.y = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
		this.z = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
		this.w = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
		return this;
	}

	// TODO
	// multiplyVector3 (quat) {};
	// toMatrix3x3 () {};
	// toMatrix4x4 () {};

	setFromRotationMatrix (matrix) {
		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
		// assumes the upper 3x3 of matrix is a pure rotation matrix (i.e, unscaled)
		var m = matrix._m;

		var m11 = m[0];
		var m12 = m[4];
		var m13 = m[8];
		var m21 = m[1];
		var m22 = m[5];
		var m23 = m[9];
		var m31 = m[2];
		var m32 = m[6];
		var m33 = m[10];

		var trace = m11 + m22 + m33;
		var s;

		if (trace > 0) {
			s = 0.5 / Math.sqrt(trace + 1);
			this.w = 0.25 / s;
			this.x = (m32 - m23) * s;
			this.y = (m13 - m31) * s;
			this.z = (m21 - m12) * s;
		} else if (m11 > m22 && m11 > m33) {
			s = 2 * Math.sqrt(1 + m11 - m22 - m33);
			this.w = (m32 - m23) / s;
			this.x = s / 4;
			this.y = (m12 + m21) / s;
			this.z = (m13 + m31) / s;

		} else if (m22 > m33) {
			s = 2 * Math.sqrt(1 + m22 - m11 - m33);
			this.w = (m13 - m31) / s;
			this.x = (m12 + m21) / s;
			this.y = s / 4;
			this.z = (m23 + m32) / s;
		} else {
			s = 2 * Math.sqrt(1 + m33 - m11 - m22);
			this.w = (m21 - m12) / s;
			this.x = (m13 + m31) / s;
			this.y = (m23 + m32) / s;
			this.z = s / 4;
		}
		return this;
	}

	getEuler () {
		var x = this.x;
		var y = this.y;
		var z = this.z;
		var w = this.w;

		var a, b, c;

		b = 2 * (x * z + w * y);

		if (Math.abs(b) < 0.99999) {
			a = Math.atan2(2 * (w * x - y * z), 1 - 2 * (x * x + y * y));
			c = Math.atan2(2 * (w * z - x * y), 1 - 2 * (y * y + z * z));
		} else {
			a = Math.atan2(2 * (y * z + w * x), 1 - 2 * (x * x + z * z));
			c = 0;
		}

		b = Math.asin(Math.max(-1, Math.min(1, b)));

		return new Vector3(a, b, c);
	}

	setFromEuler (euler, order) {
		// see http://www.euclideanspace.com/maths/geometry/rotations/conversions/eulerToQuaternion/

		var heading  = euler.x / 2;
		var attitude = euler.y / 2;
		var bank     = euler.z / 2;

		var c1 = Math.cos(heading);
		var c2 = Math.cos(attitude);
		var c3 = Math.cos(bank);

		var s1 = Math.sin(heading);
		var s2 = Math.sin(attitude);
		var s3 = Math.sin(bank);

		if (!order || order === 'XYZ') {
			this.x = s1 * c2 * c3 + c1 * s2 * s3;
			this.y = c1 * s2 * c3 - s1 * c2 * s3;
			this.z = c1 * c2 * s3 + s1 * s2 * c3;
			this.w = c1 * c2 * c3 - s1 * s2 * s3;

		} else if (order === 'YXZ') {
			this.x = s1 * c2 * c3 + c1 * s2 * s3;
			this.y = c1 * s2 * c3 - s1 * c2 * s3;
			this.z = c1 * c2 * s3 - s1 * s2 * c3;
			this.w = c1 * c2 * c3 + s1 * s2 * s3;

		} else if (order === 'ZXY') {
			this.x = s1 * c2 * c3 - c1 * s2 * s3;
			this.y = c1 * s2 * c3 + s1 * c2 * s3;
			this.z = c1 * c2 * s3 + s1 * s2 * c3;
			this.w = c1 * c2 * c3 - s1 * s2 * s3;

		} else if (order === 'ZYX') {
			this.x = s1 * c2 * c3 - c1 * s2 * s3;
			this.y = c1 * s2 * c3 + s1 * c2 * s3;
			this.z = c1 * c2 * s3 - s1 * s2 * c3;
			this.w = c1 * c2 * c3 + s1 * s2 * s3;

		} else if (order === 'YZX') {
			this.x = s1 * c2 * c3 + c1 * s2 * s3;
			this.y = c1 * s2 * c3 + s1 * c2 * s3;
			this.z = c1 * c2 * s3 - s1 * s2 * c3;
			this.w = c1 * c2 * c3 - s1 * s2 * s3;

		} else if (order === 'XZY') {
			this.x = s1 * c2 * c3 - c1 * s2 * s3;
			this.y = c1 * s2 * c3 - s1 * c2 * s3;
			this.z = c1 * c2 * s3 + s1 * s2 * c3;
			this.w = c1 * c2 * c3 + s1 * s2 * s3;
		}

		return this;
	}

	// toString () {
	// 	return '[' + this.x + ', ' + this.y + ', ' + this.z + ', ' + this.w + ']';
	// }
}

// Quaternion.slerp = function (t, quat0, quat1) {
// 	var x0 = quat0.x;
// 	var y0 = quat0.y;
// 	var z0 = quat0.z;
// 	var w0 = quat0.w;

// 	var x1 = quat1.x;
// 	var y1 = quat1.y;
// 	var z1 = quat1.z;
// 	var w1 = quat1.w;

// 	var u = t;
// 	if (x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1 < 0) {
// 		u = -t;
// 	}

// 	return new Quaternion(
// 		1 - t * x0 + u * x1,
// 		1 - t * y0 + u * y1,
// 		1 - t * z0 + u * z1,
// 		1 - t * w0 + u * w1
//    );
// };
